export const ROLE_ONBOARDING_PORTAL_USER = "APL213643-MyHelp-Apss-onbaording";
export const ROLE_ONBOARDING_PORTAL_REVIEWER =
    "APL213643-MYHELP-ONBOARDING-REVIEWER";

export const OnboardingCompaniesList = [
    "E.ON Accounting Solutions GmbH",
    "E.ON Country Hub Germany GmbH",
    "E.ON Service GmbH",
    "E.ON Solutions GmbH",
    "Energie-Pensions-Management GmbH",
    "E.ON Business Services Cluj S.R.L.",
    "Bioerdgas Schwandorf GmbH",
    "E.ON Bioerdgas GmbH",
    "E.ON Digital Technology GmbH",
    "E.ON Gas Mobil GmbH",
    "E.ON Gastronomie GmbH",
    "E.ON Group Innovation GmbH",
    "E.ON Hydrogen GmbH",
    "E.ON impulse GmbH",
    "E.ON Inhouse Consulting GmbH",
    "E.ON ONE GmbH",
    "E.ON Stiftung gGmbH",
    "E.ON SE",
    "E.ON Software Development SRL",
    "E.ON Drive Solutions UK Limited",
    "Citigen (London) Limited",
    "E.ON Energy ECO Installations Limited",
    "E.ON Energy Solutions Limited",
    "E.ON UK CHP Limited",
    "E.ON UK Heat Limited",
    "E.ON Energy Installation Services Limited",
    "E.ON UK Energy Markets Limited",
    "E.ON UK plc",
    "NPower Commercial Gas Limited",
    "E.ON Next Energy Limited",
    "e.dialog Netz GmbH",
    "E.DIS AG",
    "E.DIS Netz GmbH",
    "e.discom Telekommunikation GmbH",
    "e.disnatur Erneuerbare Energien GmbH",
    "e.distherm Energielösungen GmbH",
    "Netz- und Wartungsservice (NWS) GmbH",
    "E.ON Drive AB",
    "E.ON Drive ApS",
    "E.ON Energiinfrastruktur AB",
    "Navirum Energi AB",
    "E.ON Danmark A/S",
    "E.ON Home AB",
    "E.ON Energidistribution AB",
    "E.ON Energilösningar AB",
    "E.ON Kundsupport Sverige AB",
    "E.ON Sverige AB",
    "Westnetz GmbH",
    "Alfred Thiel-Gedächtnis-Unterstützungskasse GmbH",
    "Emscher Lippe Energie GmbH",
    "ESK GmbH",
    "EWV Energie- und Wasser-Versorgung GmbH",
    "Leitungspartner GmbH",
    "NEW AG",
    "rhenag Rheinische Energie Aktiengesellschaft",
    "RWW Rheinisch-Westfälische Wasserwerksgesellschaft mbH",
    "Stadtwerke Düren GmbH",
    "Stadtwerke Velbert GmbH",
    "Westconnect GmbH",
    "Westenergie AG",
    "Westenergie Aqua GmbH",
    "Westenergie Metering GmbH",
    "Westenergie Netzservice GmbH",
    "E.ON International Finance B.V.",
    "E.ON Distribucija plina d.o.o.",
    "Essent Sales Portfolio Management B.V.",
    "E.ON International Participations N.V.",
    "Energiewacht West Nederland B.V.",
    "Essent Energy Group B.V.",
    "Essent Energy Infrastructure Solutions B.V.",
    "Essent Energy Next Solutions B.V.",
    "Essent Hydrogen B.V.",
    "Essent IT B.V.",
    "Essent N.V.",
    "Essent Nederland B.V.",
    "Essent Retail Energie B.V.",
    "Licht Groen B.V.",
    "Volta Limburg B.V.",
    "Lechwerke AG",
    "LEW Beteiligungsgesellschaft mbH",
    "LEW Service & Consulting GmbH",
    "LEW TelNet GmbH",
    "LEW Verteilnetz GmbH",
    "LEW Wasserkraft GmbH",
    "Überlandwerk Krumbach Gesellschaft mit beschränkter Haftung",
    "Wendelsteinbahn Gesellschaft mit beschränkter Haftung",
    "Artelis S.A.",
    "Cegecom S.A.",
    "energis GmbH",
    "energis-Netzgesellschaft mbH",
    "FAMIS GmbH",
    "KEN GmbH",
    "KWS Kommunal-Wasserversorgung Saar GmbH",
    "VSE Agentur GmbH",
    "VSE Aktiengesellschaft",
    "VSE Net GmbH",
    "VSE Verteilnetz GmbH",
    "Bayernwerk AG",
    "Bayernwerk Natur GmbH",
    "Bayernwerk Netz GmbH",
    "PreussenElektra GmbH",
    "Avacon AG",
    "Avacon Connect GmbH",
    "Avacon Consult GmbH",
    "Avacon Natur GmbH",
    "Avacon Netz GmbH",
    "Avacon Wasser GmbH",
    "Celle-Uelzen Netz GmbH",
    "LSW Holding GmbH & Co. KG",
    "WEVG Salzgitter GmbH & Co. KG",
    "HanseGas GmbH",
    "HanseWerk AG",
    "HanseWerk Natur GmbH",
    "Schleswig-Holstein Netz GmbH",
    "E.ON Česká republika, s.r.o.",
    "E.ON Customer Solutions Czechia, s.r.o.",
    "E.ON Energie, a.s.",
    "E.ON Energy Solutions, s.r.o.",
    "EG.D, s.r.o.",
    "Gas Distribution s.r.o",
    "LE Montáže, s.r.o.",
    "Local Energies, a.s.",
    "E WIE EINFACH GmbH",
    "E.ON Energie Deutschland GmbH",
    "E.ON Energie Dialog GmbH",
    "E.ON Portfolio Solutions GmbH",
    "E.ON Digital Dialog d.o.o.",
    "eprimo GmbH",
    "E.ON Grid Solutions GmbH",
    "E.ON Energy Infrastructure Solutions Polska Sp. z o.o.",
    "Süwag Energie AG",
    "E.ON Polska IT Support Sp. z o.o.",
    "E.ON Polska Operations Sp. z o.o.",
    "E.ON Polska S.A.",
    "E.ON Polska Solutions Sp. z o.o.",
    "Süwag Grüne Energien und Wasser AG & Co. KG",
    "Süwag Vertrieb AG & Co. KG",
    "Syna GmbH",
    "SEC Region Sp. z o.o.",
    "SEC Serwis Sp. z o.o.",
    "SEC Zgorzelec Sp. z o.o.",
    "Stoen Operator Sp. z o.o.",
    "Szczecińska Energetyka Cieplna Sp. z o.o.",
    "E.ON Energija d.o.o.",
    "E.ON Hrvatska d.o.o.",
    "A/V/E GmbH",
    "envia Mitteldeutsche Energie AG",
    "Evailable GmbH ",
    "envia SERVICE GmbH",
    "envia TEL GmbH",
    "E.ON Dél-dunántúli Áramhálózati Zrt.",
    "E.ON Dél-dunántúli Gázhálózati Zrt.",
    "E.ON Digital Technology Hungary Kft.",
    "E.ON Energiamegoldások Kft.",
    "E.ON Energiatermelő Kft.",
    "envia THERM GmbH",
    "MITGAS Mitteldeutsche Gasversorgung GmbH",
    "E.ON Észak-dunántúli Áramhálózati Zrt.",
    "E.ON Gazdasági Szolgáltató Kft.",
    "E.ON Hungária Energetikai ZRt.",
    "E.ON Közép-dunántúli Gázhálózati Zrt.",
    "E.ON MyEnergy Kft.",
    "E.ON Ügyfélszolgálati Kft.",
    "ELMŰ Hálózati Elosztó Kft.",
    "E.ON Energy Markets GmbH",
    "E.ON Solar Solutions GmbH",
    "Delgaz Grid S.A.",
    "E.ON Dialog S.R.L.",
    "E.ON Energia S.p.A.",
    "E.ON Energie România S.A.",
    "E.ON Energy Infrastructure Solutions S.r.l.",
    "E.ON Italia S.p.A.",
    "E.ON România S.A.",
    "E.ON Super Solar S.p.A.",
    "E.ON Technical Service S.p.A.",
    "Mitteldeutsche Netzgesellschaft Gas mbH",
    "Mitteldeutsche Netzgesellschaft Strom mbH",
    "E.ON Power Plants Belgium BV",
    "HCL Technologies Germany GmbH",
    "Infosys Limited",
    "T-Systems International",
    "Wipro Limited",
    "BTB-Blockheizkraftwerks, Träger- und Betreibergesellschaft mbH Berlin",
    "E.ON Business Solutions SAS",
    "E.ON Energy Infrastructure Solutions d.o.o.",
    "DANEB Datennetze Berlin GmbH",
    "E.ON Business Solutions Deutschland GmbH",
    "E.ON Energy Infrastructure Solutions GmbH",
    "E.ON Energy Projects GmbH",
    "E.ON Energy Solutions GmbH",
    "Energienetze Berlin GmbH",
    "GSH Green Steam Hürth GmbH",
    "Sustainable Energy Aschaffenburg GmbH",
    "E.ON Drive Austria GmbH",
    "E.ON Drive GmbH",
    "E.ON Drive France SAS",
    "E.ON Drive Spain S.L.",
    "Západoslovenská distribučná, a.s.",
].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }));

export const OnboardingCompanyIdToNameMap = {
    "1": "E.ON SE",
    "45": "E.ON Italia S.p.A.",
    "90": "E.ON International Finance B.V.",
    "167": "E.ON Group Innovation GmbH",
    "400": "HanseWerk AG",
    "402": "HanseGas GmbH",
    "794": "Celle-Uelzen Netz GmbH",
    "1242": "E.ON Energy Infrastructure Solutions GmbH",
    "1255": "E.ON Country Hub Germany GmbH",
    "1267": "E.ON Business Services Cluj S.R.L.",
    "1297": "E.ON Accounting Solutions GmbH",
    "1319": "E.ON Energy Infrastructure Solutions S.r.l.",
    "1441": "Avacon Consult GmbH",
    "1445": "E.ON Drive GmbH",
    "1451": "E.ON Business Solutions SAS",
    "1515": "Energie-Pensions-Management GmbH",
    "1516": "E.ON UK Energy Markets Limited",
    "1525": "SEC Serwis Sp. z o.o.",
    "1628": "E.ON Dél-dunántúli Gázhálózati Zrt.",
    "1836": "E.ON Service GmbH",
    "1855": "Szczecińska Energetyka Cieplna Sp. z o.o.",
    "1919": "E.ON Energiamegoldások Kft.",
    "1924": "E.ON Energia S.p.A.",
    "1930": "Delgaz Grid S.A.",
    "1989": "E.ON Gas Mobil GmbH",
    "1990": "E.ON Bioerdgas GmbH",
    "1991": "E.ON România S.A.",
    "1996": "E.ON Energie România S.A.",
    "2000": "Bayernwerk AG",
    "2002": "E.ON Sverige AB",
    "2181": "E.ON Energy Projects GmbH",
    "2188": "PreussenElektra GmbH",
    "2211": "e.distherm Energielösungen GmbH",
    "2235": "Avacon Netz GmbH",
    "2236": "E.DIS Netz GmbH",
    "2240": "E.ON Digital Technology GmbH",
    "2350": "Avacon AG",
    "2410": "E.ON Česká republika, s.r.o.",
    "2412": "E.ON Hungária Energetikai ZRt.",
    "2442": "E.ON Energiatermelő Kft.",
    "2444": "E.ON Dél-dunántúli Áramhálózati Zrt.",
    "2484": "E.ON Észak-dunántúli Áramhálózati Zrt.",
    "2510": "E.ON Digital Technology Hungary Kft.",
    "2555": "E.ON Közép-dunántúli Gázhálózati Zrt.",
    "2700": "Bayernwerk Natur GmbH",
    "2743": "e.disnatur Erneuerbare Energien GmbH",
    "3087": "e.discom Telekommunikation GmbH",
    "5505": "E.ON UK plc",
    "5523": "E.ON UK CHP Limited",
    "5524": "E.ON Energy ECO Installations Limited",
    "5539": "E.ON Energy Solutions Limited",
    "5823": "Citigen (London) Limited",
    "5960": "E.ON Energy Installation Services Limited",
    "11150": "E.DIS AG",
    "20008": "WEVG Salzgitter GmbH & Co. KG",
    "20020": "HanseWerk Natur GmbH",
    "20082": "E.ON Energilösningar AB",
    "20106": "E.ON Energidistribution AB",
    "20120": "E.ON Energiinfrastruktur AB",
    "20131": "E.ON Danmark A/S",
    "20288": "Bayernwerk Netz GmbH",
    "20293": "Avacon Wasser GmbH",
    "20371": "E.ON Inhouse Consulting GmbH",
    "20446": "LSW Holding GmbH & Co. KG",
    "20497": "E WIE EINFACH GmbH",
    "20583": "e.dialog Netz GmbH",
    "20648": "E.ON Hydrogen GmbH",
    "20665": "E.ON Energy Infrastructure Solutions Polska Sp. z o.o.",
    "20673": "E.ON Energie, a.s.",
    "20728": "Netz- und Wartungsservice (NWS) GmbH",
    "20753": "E.ON Energie Dialog GmbH",
    "20764": "E.ON Gazdasági Szolgáltató Kft.",
    "20789": "Local Energies, a.s.",
    "20801": "E.ON Ügyfélszolgálati Kft.",
    "20814": "E.ON Grid Solutions GmbH",
    "20855": "Bioerdgas Schwandorf GmbH",
    "20865": "E.ON Energie Deutschland GmbH",
    "20874": "E.ON Software Development SRL",
    "20898": "E.ON Power Plants Belgium BV",
    "20921": "Avacon Natur GmbH",
    "20949": "SEC Region Sp. z o.o.",
    "20952": "Schleswig-Holstein Netz GmbH",
    "21025": "E.ON Energy Solutions GmbH",
    "21065": "GSH Green Steam Hürth GmbH",
    "23076": "E.ON Kundsupport Sverige AB",
    "70000": "E.ON Solutions GmbH",
    "70025": "E.ON Technical Service S.p.A.",
    "70071": "E.ON Dialog S.R.L.",
    "70114": "E.ON Business Solutions Deutschland GmbH",
    "70133": "E.ON Drive France SAS",
    "70144": "E.ON Super Solar S.p.A.",
    "70146": "Sustainable Energy Aschaffenburg GmbH",
    "70173": "E.ON Energy Markets GmbH",
    "70176": "E.ON Portfolio Solutions GmbH",
    "70204": "E.ON Drive Solutions UK Limited",
    "70230": "E.ON ONE GmbH",
    "70235": "E.ON Digital Dialog d.o.o.",
    "70260": "SEC Zgorzelec Sp. z o.o.",
    "70314": "LE Montáže, s.r.o.",
    "70335": "Navirum Energi AB",
    "70351": "E.ON Energy Infrastructure Solutions d.o.o.",
    "70391": "E.ON Solar Solutions GmbH",
    "70392": "Evailable GmbH ",
    "70405": "E.ON Drive Austria GmbH",
    "70439": "E.ON Energy Solutions, s.r.o.",
    "70441": "Essent Hydrogen B.V.",
    "70450": "E.ON Home AB",
    "70451": "E.ON Drive AB",
    "70460": "E.ON Drive ApS",
    "70512": "E.ON Customer Solutions Czechia, s.r.o.",
    "70577": "Gas Distribution s.r.o",
    "70578": "EG.D, s.r.o.",
    "70582": "E.ON Drive Spain S.L.",
    "72360": "Avacon Connect GmbH",
    "75963": "E.ON UK Heat Limited",
    "85107": "Západoslovenská distribučná, a.s.",
    "85811": "Wipro Limited",
    "85812": "Infosys Limited",
    "85813": "HCL Technologies Germany GmbH",
    "85901": "T-Systems International",
    "801103": "Lechwerke AG",
    "801111": "rhenag Rheinische Energie Aktiengesellschaft",
    "801116": "LEW Wasserkraft GmbH",
    "801133": "Überlandwerk Krumbach Gesellschaft mit beschränkter Haftung",
    "801181": "EWV Energie- und Wasser-Versorgung GmbH",
    "801307": "Syna GmbH",
    "801309": "Süwag Vertrieb AG & Co. KG",
    "801369": "E.ON Gastronomie GmbH",
    "801507": "Wendelsteinbahn Gesellschaft mit beschränkter Haftung",
    "801587": "E.ON Polska S.A.",
    "801611": "Emscher Lippe Energie GmbH",
    "801646": "E.ON Polska Solutions Sp. z o.o.",
    "801908": "Süwag Energie AG",
    "802015": "envia TEL GmbH",
    "802020": "LEW TelNet GmbH",
    "802432": "Westenergie Aqua GmbH",
    "802504": "Alfred Thiel-Gedächtnis-Unterstützungskasse GmbH",
    "802557": "LEW Service & Consulting GmbH",
    "802627": "envia Mitteldeutsche Energie AG",
    "802983": "E.ON Stiftung gGmbH",
    "803066": "Westnetz GmbH",
    "803069": "envia SERVICE GmbH",
    "803073": "Stadtwerke Velbert GmbH",
    "803113": "Východoslovenská energetika Holding a.s.",
    "803128": "Stadtwerke Düren GmbH",
    "803140": "Mitteldeutsche Netzgesellschaft Strom mbH",
    "803143": "LEW Verteilnetz GmbH",
    "803182": "LEW Beteiligungsgesellschaft mbH",
    "803187": "VSE Aktiengesellschaft",
    "803288": "energis GmbH",
    "803289": "VSE Net GmbH",
    "803290": "FAMIS GmbH",
    "803360": "E.ON impulse GmbH",
    "803370": "E.ON Hrvatska d.o.o.",
    "803783": "Cegecom S.A.",
    "803787": "Artelis S.A.",
    "803942": "NEW AG",
    "803999": "ELMŰ Hálózati Elosztó Kft.",
    "804061": "eprimo GmbH",
    "804074": "KEN GmbH",
    "804076": "KWS Kommunal-Wasserversorgung Saar GmbH",
    "804204": "RWW Rheinisch-Westfälische Wasserwerksgesellschaft mbH",
    "804360": "Mitteldeutsche Netzgesellschaft Gas mbH",
    "804370": "Stoen Operator Sp. z o.o.",
    "804372": "VSE Verteilnetz GmbH",
    "804374": "energis-Netzgesellschaft mbH",
    "804375": "VSE Agentur GmbH",
    "804385": "Süwag Grüne Energien und Wasser AG & Co. KG",
    "804391": "Energienetze Berlin GmbH",
    "804587": "E.ON MyEnergy Kft.",
    "804588": "E.ON Energy Infrastructure Solutions d.o.o.",
    "804699": "Westenergie AG",
    "804982": "E.ON Energija d.o.o.",
    "805138": "Westenergie Metering GmbH",
    "805305": "Westconnect GmbH",
    "805339": "Leitungspartner GmbH",
    "805830": "E.ON Next Energy Limited",
    "805836": "NPower Commercial Gas Limited",
    "806201": "Essent N.V.",
    "806202": "Essent Nederland B.V.",
    "806208": "Essent IT B.V.",
    "806212": "Volta Limburg B.V.",
    "806223": "Essent Retail Energie B.V.",
    "806248": "Essent Energy Group B.V.",
    "806277": "Essent Energy Infrastructure Solutions B.V.",
    "806364": "Essent Sales Portfolio Management B.V.",
    "806455": "Energiewacht West Nederland B.V.",
    "806482": "Essent Energy Next Solutions B.V.",
    "806491": "Licht Groen B.V.",
    "807049": "Westenergie Netzservice GmbH",
    "808375": "DANEB Datennetze Berlin GmbH",
    "808535": "E.ON Distribucija plina d.o.o.",
    "808611": "A/V/E GmbH",
    "808615": "envia THERM GmbH",
    "808694": "E.ON Polska IT Support Sp. z o.o.",
    "808695": "E.ON Polska Operations Sp. z o.o.",
    "808754":
        "BTB-Blockheizkraftwerks, Träger- und Betreibergesellschaft mbH Berlin",
    "808818": "MITGAS Mitteldeutsche Gasversorgung GmbH",
    "808831": "ESK GmbH",
    "808842": "E.ON International Participations N.V.",
};

export const OnboardingCompanyIds = Object.keys(OnboardingCompanyIdToNameMap).sort(
    (a, b) =>
        OnboardingCompanyIdToNameMap[a as keyof typeof OnboardingCompanyIdToNameMap].localeCompare(
            OnboardingCompanyIdToNameMap[b as keyof typeof OnboardingCompanyIdToNameMap],
            undefined,
            { sensitivity: "base" },
        ),
);

export const DefaultIconsList = [
    "add",
    "alert",
    "all_in_one",
    "all_in_one_alt",
    "arrow_down",
    "arrow_left",
    "arrow_right",
    "arrow_small_down",
    "arrow_small_left",
    "arrow_small_right",
    "arrow_small_up",
    "arrow_up",
    "ask_eon",
    "battery-0",
    "battery-25",
    "battery-50",
    "battery-75",
    "battery-full",
    "bookmark_filled",
    "bookmark_outline",
    "briefcase",
    "bulb",
    "bulb_idea",
    "bulletlist",
    "bulletlist_square",
    "calendar",
    "call-center",
    "camera",
    "camera_video",
    "camera_video_alt",
    "car_electric",
    "change_contract_01",
    "change_contract_01_alt",
    "change_contract_02",
    "change_contract_02_alt",
    "chart_bar",
    "chart_pie",
    "chat",
    "chat_settings",
    "check_carrier",
    "checkbox",
    "checkbox_checked",
    "checkbox_checked_inverted",
    "checkbox_filled",
    "checkbox_inverted",
    "checkbox_mixed",
    "checkbox_mixed_inverted",
    "chevron_bold_down",
    "chevron_bold_left",
    "chevron_bold_right",
    "chevron_bold_up",
    "chevron_circle_down",
    "chevron_circle_left",
    "chevron_circle_right",
    "chevron_circle_up",
    "chevron_small_down",
    "chevron_small_left",
    "chevron_small_right",
    "chevron_small_up",
    "clock",
    "clock_alt",
    "close",
    "close_minimize",
    "collect_download",
    "collect_download_selected",
    "comma_digits",
    "communities",
    "compare",
    "compare_alt",
    "consumption",
    "contract",
    "contract_alt",
    "contract_alt_2",
    "copy",
    "credit_card",
    "cross",
    "cross_carrier",
    "currency_dollar",
    "currency_dollar_alt",
    "currency_euro",
    "currency_pound",
    "dashboard",
    "dashboard_02",
    "dashboard_alt_1",
    "dashboard_alt_2",
    "datepicker",
    "digit_0",
    "digit_0_light",
    "digit_0_solid",
    "digit_1",
    "digit_1_light",
    "digit_1_solid",
    "digit_2",
    "digit_2_light",
    "digit_2_solid",
    "digit_3",
    "digit_3_light",
    "digit_3_solid",
    "digit_4",
    "digit_4_light",
    "digit_4_solid",
    "digit_5",
    "digit_5_light",
    "digit_5_solid",
    "digit_6",
    "digit_6_light",
    "digit_6_solid",
    "digit_7",
    "digit_7_light",
    "digit_7_solid",
    "digit_8",
    "digit_8_light",
    "digit_8_solid",
    "digit_9",
    "digit_9_light",
    "digit_9_solid",
    "digitalisation",
    "divide",
    "download",
    "download_carrier",
    "dragndrop",
    "dragndrop_alt",
    "edit",
    "edit_no_line",
    "electricity",
    "electricity_filled",
    "emergency_numbers",
    "equal_sign",
    "error",
    "expand",
    "facebook",
    "favourite",
    "favourite_outline",
    "fax",
    "file",
    "file_alert",
    "file_image",
    "file_pdf",
    "filter",
    "floor_plan",
    "forward",
    "fullscreen_enter",
    "fullscreen_exit",
    "funnel",
    "gas",
    "get_in_touch",
    "gift",
    "graph_growth",
    "heat",
    "home",
    "home_add_solution",
    "home_add_solution_alt",
    "home_green",
    "home_green_alt",
    "home_services",
    "home_services_alt",
    "home_setup",
    "home_solutions",
    "hydrogen",
    "info",
    "info_large",
    "info_large_filled",
    "info_secondary",
    "info_secondary_large",
    "info_tertiary",
    "landline",
    "lang_select",
    "link_external",
    "location",
    "lock",
    "logo_eon",
    "logout",
    "menu",
    "menu_small",
    "messenger_01",
    "meter_read",
    "meter_read_add",
    "meter_read_add_01",
    "meter_read_add_alt",
    "meter_read_alt",
    "meter_read_auto",
    "meter_read_auto_02",
    "meter_read_auto_02_alt",
    "meter_read_auto_alt",
    "meter_read_no_read",
    "meter_read_no_read_alt",
    "mobile",
    "modular",
    "more",
    "more_small",
    "my_product",
    "newsfeed",
    "newsfeed_alt",
    "notification",
    "notification_bell",
    "notification_outline",
    "open-folder",
    "open_maximize",
    "option",
    "pages",
    "password_invisible",
    "password_visible",
    "pause",
    "payment",
    "pc_mac",
    "phone",
    "play",
    "play_carrier",
    "play_filled",
    "plug-2-pin",
    "plug-3-pin",
    "plug_cable",
    "plug_wall",
    "printer",
    "profile_logged_in",
    "protection",
    "put-into-folder",
    "pylon",
    "question_mark",
    "quote",
    "quote_filled",
    "radiator",
    "radio",
    "radio_checkbox_ring",
    "radio_checkbox_ring_02",
    "radio_checkbox_ring_03",
    "radio_checkbox_tick",
    "radio_filled",
    "rating-star-empty",
    "rating-star-half",
    "rating-star-outline",
    "rating-star",
    "rating_negative",
    "rating_neutral",
    "rating_positive",
    "reload",
    "reward_program",
    "reward_program_alt",
    "rewind",
    "save",
    "save_2",
    "search",
    "send",
    "settings",
    "shading",
    "share",
    "shell",
    "shopping_cart",
    "shopping_cart_add",
    "shopping_cart_added",
    "slider",
    "smartphone",
    "smartphone_checked",
    "snowflake",
    "social_connect",
    "social_facebook",
    "social_glass_door",
    "social_google_plus",
    "social_instagram",
    "social_kununu",
    "social_linked_in",
    "social_pinterest",
    "social_share",
    "social_share_alt",
    "social_snapchat",
    "social_spotify",
    "social_tiktok",
    "social_twitter",
    "social_whatsapp",
    "social_xing",
    "social_youtube",
    "solar_panel",
    "star",
    "step",
    "stop",
    "stop_filled",
    "subtract",
    "sun",
    "sustainability",
    "sustainability_alt",
    "tablet",
    "tablet_alt",
    "tag",
    "talk_to_us",
    "television",
    "thermometer",
    "thermostat_analog",
    "thermostat_digital",
    "thermostatic-radiator-valve",
    "thumb_up",
    "toolkit",
    "trash_bin",
    "tree_large",
    "upload",
    "upload_carrier",
    "user",
    "user_group",
    "user_group_alt",
    "user_outline",
    "value_proposition",
    "video_replay",
    "volume_mute",
    "volume_normal",
    "water",
    "water_filled",
    "wifi",
    "wind",
    "wind_alt",
];
